import { UserLocation } from 'api/userLocation';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { Action } from '../actions/userLocation';

export type State = UserLocation & {
  isFetching?: boolean;
  isLoaded?: boolean;
};
// @ts-expect-error ts-migrate(2322) FIXME: Type '{}' is not assignable to type 'State'.
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/default-param-last
export default function userLocation(state: State = {}, action: Action) {
  switch (action.type) {
    case 'USER_LOCATION_FETCH_REQUEST':
      return { ...state, isFetching: true };

    case 'USER_LOCATION_FETCH_SUCCESS':
      return { ...action.userLocation, isFetching: false, isLoaded: true };

    default:
      // this causes a flow error if there are any unhandled actions
      action as never; // eslint-disable-line no-unused-expressions

      return state;
  }
}
